<template>
  <div class="item" style="padding-left: .46rem">
    <i class="iconfont icon-gengxin-xuankuang" v-if="!isChecked" @click="chooseMember(item)"></i>
    <i class="iconfont icon-xuankuang" v-if="isChecked" @click="chooseMember(item)"></i>
    {{item.userInfoName}}
  </div>
</template>

<script>
  import * as getData from '../service/getData'
  import * as global from '../config/mUtils'

  export default {
    name: 'items',
    data () {
      return {
        isChecked: false,
      }
    },
    props: ['item'],
    created () {
      //console.log(this.item)
      this.$store.state.selectedMembersId.forEach((ids, index) => {
        if (ids.userInfoId === this.item.userInfoId) {
          this.isChecked = true;
          return
        }
      })
    },
    computed: {},
    methods: {
      chooseMember (item) {
        this.isChecked = !this.isChecked;
        if (this.isChecked) {
          this.$store.state.chooseMembersId = item;
        } else {
          this.$store.state.deleteMembersId = item;
        }
      }
    },
    components: {},
    watch: {
    }
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .item{
    line-height: .88rem;
    @include sc(.28rem,#333);
    font-weight: 700;
    i{
      display: inline-block;
      @include sc(.28rem,#676A88);
      margin-right: .16rem;
      &.icon-xuankuang{
        color: #009DFF;
      }
    }
    &.active{
      border-bottom: .02rem solid #eee;
    }
    &:last-child{
      border-bottom: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// checkbox.vue?46404943